import { render } from "./iveButton.vue?vue&type=template&id=bba15032&scoped=true"
import script from "./iveButton.vue?vue&type=script&lang=js"
export * from "./iveButton.vue?vue&type=script&lang=js"

import "./iveButton.vue?vue&type=style&index=0&id=bba15032&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bba15032"]])

export default __exports__